@import "../../../global/gx-ide-common";

:host {
  display: inline-grid;
}

.item-content {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-gap-xs);
}

.action {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-gap-xs);
  padding-block: var(--spacing-padding-xxs);
  padding-inline: var(--spacing-padding-xs);
  border: none;
  border-radius: 4px;
  background: transparent;
  text-decoration: none;
  cursor: pointer;
  font: inherit;

  /* Color for button only; links use Mercury .link-primary */
  &:not(a) {
    color: var(--color-text-interactive-default);
  }

  &:hover:not(.disabled) {
    background-color: var(--color-accent-surface-elevation-1-hover);
  }

  &:not(a):hover:not(.disabled) {
    color: var(--color-text-interactive-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--color-border-focus-default);
    outline-offset: -2px;
  }

  &.disabled {
    color: var(--color-text-neutral-disabled);
    cursor: not-allowed;
  }

  &.selected {
    color: var(--color-text-primary-default);
  }
}

.caption {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item__img {
  flex-shrink: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  &:not(.item__img-icon) {
    inline-size: var(--icon-s);
    block-size: var(--icon-s);
  }

  &--mask {
    background-color: currentColor;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
